import type Player from 'video.js/dist/types/player';
import type Button from 'video.js/dist/types/button';
import videojs from 'video.js';
const VjsButton = videojs.getComponent('Button') as typeof Button;
function detectFPS(video: HTMLVideoElement): Promise<number> {
  return new Promise((resolve) => {
    let meta1: any = null;
    let meta2: any = null;
    if (!video.requestVideoFrameCallback) {
      resolve(30); // Default fallback FPS
      return;
    }
    // 1st frame
    video.requestVideoFrameCallback((_1, metadata1) => {
      meta1 = metadata1;

      // 2nd frame
      video.requestVideoFrameCallback((_2, metadata2) => {
        meta2 = metadata2;

        // Frames increased by 1? Then we know timing.
        const frameDelta =
          meta2.presentedFrames - meta1.presentedFrames || 1;

        const timeDelta =
          meta2.mediaTime - meta1.mediaTime;

        const fps =
          timeDelta > 0 ? Math.round(frameDelta / timeDelta) : 30;

        resolve(fps);
      });
    });
  });
}



export class NextFrameButton extends VjsButton {
  fps = 25;

  constructor(player: Player, options: any) {
    super(player, options);
    this.addClass('vjs-next-frame');
    this.controlText('Next Frame');

    // calculate fps once video starts
    player.on('loadedmetadata', () => {
      const video = player.el().querySelector('video');
      detectFPS(video).then((fps) => this.fps = fps);
    });
  }

  override handleClick() {
    const player = this.player();
    const speed = player.playbackRate();
    player.pause();
    player.currentTime(player.currentTime() + ((1 / this.fps) * speed));
  }
}

export class PrevFrameButton extends VjsButton {
  fps = 25;

  constructor(player: Player, options: any) {
    super(player, options);
    this.addClass('vjs-prev-frame');
    this.controlText('Previous Frame');

    player.on('loadedmetadata', () => {
      const video = player.el().querySelector('video');
      detectFPS(video).then((fps) => this.fps = fps);
    });
  }

  override handleClick() {
    const player = this.player();
    const speed = player.playbackRate();
    player.pause();
    player.currentTime(player.currentTime() - ((1 / this.fps) * speed));
  }
}


